<template>
  <div>
    <div id="list" v-if="viewType == 'list'">
      <div class="row center-block">
        <div class="col-md-12">
          <div class="box">
            <div class="box-header">
                <label for="recordPerPage" class="col-sm-1 col-md-1 col-lg-1" style="margin-top: 10px; text-align:left">Show</label>
                <div class="col-sm-2 col-md-2 col-lg-1" style="padding-left:0px;">
                  <select v-on:change="changePageSize" ref="recordPerPage" class="form-control">
                    <option v-if="inquiryParam.pageSize == 5" selected>5</option><option v-else>5</option>
                    <option v-if="inquiryParam.pageSize == 10" selected>10</option><option v-else>10</option>
                    <option v-if="inquiryParam.pageSize == 20" selected>20</option><option v-else>20</option>
                    <option v-if="inquiryParam.pageSize == 50" selected>50</option><option v-else>50</option>
                    <option v-if="inquiryParam.pageSize == 100" selected>100</option><option v-else>100</option>
                  </select>
                </div>          
                <div class="box-tools">              
                  <button v-on:click="onCreate" class="btn btn-primary">Create</button>
                  <button v-on:click="inquiry" class="btn btn-warning">Search</button>
                </div>
            </div>        
            <div class="box-body no-padding table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th style="width: 45px;text-align:center;">#</th>
                    <th>Action</th>
                    <th>Cart No</th>
                    <th>Cart Description</th>
                    <th>status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, i) in listData" v-bind:key="i">
                    <td style="width:45px;text-align:center;">{{ startSequence + i + 1}}</td>
                    <td style="width:85px;text-align:left;">
                      <a href="#" v-on:click="onDisplay(row)" ref="displayRow" style="padding-right:5px">
                        <span class="icon ion-search" data-toggle="tooltip" data-placement="right" title="Display"></span>
                      </a>
                      <a href="#" v-on:click="onEdit(row)" ref="editRow" style="padding-right:5px">
                        <span class="icon ion-edit" data-toggle="tooltip" data-placement="right" title="Edit"></span>
                      </a>
                      <a href="#" v-on:click="onDelete(row)" ref="deleteRow" style="padding-right:5px">
                        <span class="icon ion-ios-trash" data-toggle="tooltip" data-placement="right" title="Delete"></span>
                      </a>
                    </td>
                    <td>{{ row.cartNumber }}</td>
                    <td>{{ row.brand }}</td>
                    <td>{{ row.status }}</td>
                    <td hidden>{{ row.id }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="box-footer">
              <div class="form-group">
                <label style="width:25px;text-align:right;">
                    <a href="#"><i v-on:click="changePage(1)" class="icon ion-ios-rewind"></i></a>
                </label>
                <label style="width:35px;text-align:center;">
                    <a href="#"><i v-on:click="changePage(inquiryParam.CurrentPageNumber - 1)" class="icon ion-arrow-left-b"></i></a>
                </label>
                <label>
                    Page
                </label>
                <label>
                    <input v-model="inquiryParam.CurrentPageNumber" v-on:keyup.enter="gotoPage($event)" type="text" class="form-control" id="CurrentPage" style="width:50px;margin-left:5px;margin-right:5px;">
                </label>
                <label id="TotalPageText">
                  {{ totalPages }}                
                </label>
                <label style="width:35px;text-align:center;">
                    <a href="#"><i v-on:click="changePage(inquiryParam.CurrentPageNumber + 1)" class="icon ion-arrow-right-b"></i></a>
                </label>
                <label style="width:25px;text-align:left;">
                    <a href="#"><i v-on:click="changePage(totalPages)" class="icon ion-ios-fastforward"></i></a>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div id="form" v-if="viewType == 'form'">
        <div class="row center-block">
          <div class="col-md-12">
            <div class="box box-info">
              <!-- <div class="box-header with-border">
                <h3 class="box-title">Horizontal Form</h3>
              </div> -->
              <form @submit.prevent class="form-horizontal">
                <div class="box-body">
                  <div class="form-group">
                    <label for="inputCartNumber" class="col-sm-2 control-label">Cart Code</label>

                    <div class="col-sm-10">
                      <input :disabled="viewMode == MODE_VIEW" class="form-control" id="inputName" placeholder="Cart Code" v-model="formData.cartNumber">
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="inputCartDescription" class="col-sm-2 control-label">Cart Description</label>

                    <div class="col-sm-10">
                      <input :disabled="viewMode == MODE_VIEW" class="form-control" id="inputName" placeholder="Cart Description" v-model="formData.brand">
                    </div>
                  </div>

                   <div class="form-group">
                    <label for="inputStatusCart" class="col-sm-2 control-label">Consingment</label>
                    <label class="radio-inline">
                    <input :disabled="viewMode == MODE_VIEW"
                    type="radio"
                    value="Yes"
                    v-model="formData.Congsigment">
                    Yes
                </label>

                <label class="radio-inline">
                    <input :disabled="viewMode == MODE_VIEW"
                    type="radio"
                    value="No"
                    v-model="formData.Congsigment">
                    No
                </label>
                  </div>
                    <div class="form-group">
                    <label for="inputCartDate" class="col-sm-2 control-label">Start Date</label>

                    <div class="col-sm-10">
                      <input :disabled="viewMode == MODE_VIEW" type="date" class="form-control" id="inputName" placeholder="Cart Date" v-model="formData.startDate">
                    </div>
                  </div>

                  <div class="form-group">

                  <label class="col-sm-2 control-label">
                    Consignment Code
                  </label>

                  <div
                    class="col-sm-10"
                    style="display:flex; align-items:center;">

                    <!-- Code -->
                    <input
                      :disabled="viewMode == MODE_VIEW"
                      type="text"
                      class="form-control"
                      style="width:120px;"
                      v-model="formData.consignmentCode"
                      readonly>

                    <!-- Button Lookup -->
                    <button
                      type="button"
                      class="btn btn-default"
                      style="margin:0 4px;"
                      @click="openConsignmentLookup">
                      ...
                    </button>

                    <!-- Description -->
                    <input
                      :disabled="true"
                      type="text"
                      class="form-control"
                      v-model="formData.consignmentDesc">

                  </div>

                </div>
                <div class="form-group">
                    <label for="inputStatusCart" class="col-sm-2 control-label">Cart Capacity</label>
                    <label class="radio-inline">
                    <input :disabled="viewMode == MODE_VIEW"
                    type="radio"
                    value="2"
                    v-model="formData.passengerCapacity">
                    2
                </label>

                <label class="radio-inline">
                    <input :disabled="viewMode == MODE_VIEW"
                    type="radio"
                    value="4"
                    v-model="formData.passengerCapacity">
                    4
                </label>
                <label class="radio-inline">
                    <input :disabled="viewMode == MODE_VIEW"
                    type="radio"
                    value="6"
                    v-model="formData.passengerCapacity">
                    6
                </label>
                  </div>

                  <div class="form-group">
                    <label for="inputStatusCart" class="col-sm-2 control-label">Status</label>
                    <label class="radio-inline">
                    <input :disabled="viewMode == MODE_VIEW"
                    type="radio"
                    value="Active"
                    v-model="formData.status">
                    Active
                </label>

                <label class="radio-inline">
                    <input :disabled="viewMode == MODE_VIEW"
                    type="radio"
                    value="Inactive"
                    v-model="formData.status">
                    Inactive
                </label>
                  </div>

                   <div class="form-group">
                    <label for="inputCartDescription" class="col-sm-2 control-label">Last Maintenance</label>

                    <div class="col-sm-10">
                      <input :disabled="viewMode == MODE_VIEW" class="form-control" id="inputName" placeholder="Last Maintenance" v-model="formData.lastMaintenance">
                    </div>
                  </div>


                     <div class="form-group">
                    <label for="inputCartType" class="col-sm-2 control-label">Cart Type</label>

                    <div class="col-sm-10">
                      <input :disabled="viewMode == MODE_VIEW" class="form-control" id="inputName" placeholder="Cart Type" v-model="formData.cartType">
                    </div>
                  </div>

                  <input type="hidden" class="form-control" id="inputId" v-model="formData.id">

                    <div class="form-group">

                    <label class="col-sm-2 control-label">
                        Update by
                    </label>
                    <div class="col-sm-10" style="display:flex; align-items:center;">

                      <input
                        :disabled="viewMode == MODE_VIEW"
                        type="date"
                        class="form-control"
                        style="width:180px;"
                        v-model="formData.updateBy">

                      <input
                        :disabled="viewMode == MODE_VIEW"
                        type="text"
                        class="form-control"
                        style="width:220px; margin-left:8px;"
                        v-model="formData.firstName">

                    </div>
                    </div>
                </div>
                <!-- /.box-body -->
                <div class="box-footer">
                  <div class="box-tools">
                    <button @click="onBack()" class="btn btn-default" style="margin-right:15px;">Back</button>
                    <button @click="onCancel()" class="btn btn-warning">Cancel</button>
                    <button v-if="viewMode != MODE_VIEW" @click="onSave()" class="btn btn-info pull-right">Save</button>
                    <button v-if="viewMode == MODE_VIEW" @click="onEdit(formData)" class="btn btn-info pull-right">Edit</button>
                    <button v-if="viewMode == MODE_VIEW" @click="onCreate()" class="btn btn-info pull-right" style="margin-right:15px;">Create</button>
                  </div>
                </div>
                <!-- /.box-footer -->
              </form>
            </div>          
          </div>
        </div>
      </div> 
    </transition>  
  </div>  
</template>

<script>
import api from '../../../api'
import SweetAlert from 'sweetalert2'

const VIEW_LIST = 'list'
const VIEW_FORM = 'form'
const MODE_NONE = 'none'
const MODE_CREATE = 'create'
const MODE_VIEW = 'read'
const MODE_UPDATE = 'update'

export default {
  name: 'Cart',
  data() {
    return {
      VIEW_LIST: VIEW_LIST,
      VIEW_FORM: VIEW_FORM,
      MODE_NONE: MODE_NONE,
      MODE_VIEW: MODE_VIEW,
      MODE_UPDATE: MODE_UPDATE,
      column: '',
      item: null,
      listData: null,
      totalRows: 0,
      totalPages: 0,
      startSequence: 0,
      inquiryParam: {
        WhereClause: '',
        CurrentPageNumber: 1,
        PageSize: 10,
        SortDirection: 'ASC',
        SortExpression: 'Name'
      },
      viewType: VIEW_LIST,
      viewMode: MODE_NONE,
      formData: {
        id: 0,
        cartNumber: '',
        serialNumber: '',
        brand: 'cart description',
        model: 'Golf Cart',
        cartType: '01121',
        passengerCapacity: '4',
        status: 'Active',
        isActivated: 'true',
        lastMaintenance: '2026-01-01T09:41:29.000Z'
      }
    }
  },
  created() {
    this.viewType = VIEW_LIST
    this.inquiry()
  },
  mounted() {
    this.$refs.recordPerPage.value = this.inquiryParam.PageSize
  },
  methods: {
    changePageSize(evt) {
      this.inquiryParam.PageSize = evt.target.value
      this.inquiryParam.CurrentPageNumber = 1
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    gotoPage(evt) {
      if (evt.target.value > this.totalPages) {
        this.inquiryParam.CurrentPageNumber = this.totalPages
      } else if (evt.target.value < 1) {
        this.inquiryParam.CurrentPageNumber = 1
      }
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    changePage(page) {
      if (page < 1) {
        this.inquiryParam.CurrentPageNumber = 1
      } else if (page > this.totalPages) {
        this.inquiryParam.CurrentPageNumber = this.totalPages
      } else {
        this.inquiryParam.CurrentPageNumber = page
      }
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    inquiry() {
      api
        .request('Golf', 'get', '/api/golf/masters/cartMaster?limit=' + this.inquiryParam.PageSize + '&page=' + this.inquiryParam.CurrentPageNumber, null)
        .then(response => {
          var data = response.data
          this.listData = data.entity
          this.total = data.totalRows
          this.totalPages = data.totalPages
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    initForm() {
      this.formData.name = ''
    },
    onCreate() {
      this.initForm()
      this.viewType = VIEW_FORM
      this.viewMode = MODE_CREATE
    },
    onDisplay(row) {
      this.viewType = VIEW_FORM
      this.viewMode = MODE_VIEW

      this.formData.id = row.id
      this.formData.name = row.name
    },
    onEdit(data) {
      this.formData.id = data.id
      this.formData.cartNumber = data.cartNumber
      this.formData.serialNumber = data.serialNumber
      this.formData.status = data.status
      this.viewType = VIEW_FORM
      this.viewMode = MODE_UPDATE
    },
    onDelete(data) {
      SweetAlert.fire({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: true
      })
      .then((result) => {
        if (result.value) {
          var res = this.delete(data)
          SweetAlert.fire('Deleted', res.message, res.status)
        } else if (result.dismiss === SweetAlert.DismissReason.cancel) {
          SweetAlert.fire('Cancelled', 'Your data is still exist', 'info')
        }
      })
    },
    onCancel() {
      this.initForm()
    },
    onBack() {
      this.inquiry()
      this.viewType = VIEW_LIST
    },
    onSave() {
      var data = {
        Id: this.formData.id,
        cartNumber: this.formData.cartNumber,
        serialNumber: this.formData.serialNumber,
        Status: this.formData.status
      }

      var status = 'success'
      var message = ''
      var method = ''
      switch (this.viewMode) {
        case MODE_CREATE:
          method = 'Create'
          break
        case MODE_UPDATE:
          method = 'Update'
          break
      }

      api
        .request('Golf', 'post', '/api/golf/masters/cartMaster' + method, data)
        .then(response => {
          var resData = response.data
          this.formData = resData.entity
          this.total = resData.totalRows

          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage.join('<br>')
          SweetAlert.fire(status, message, status)

          if (resData.returnStatus) {
            this.onDisplay({id: this.formData.id, name: this.formData.name})
          }
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    delete(data) {
      var status = ''
      var message = ''
      var reqData = {
        Id: data.id,
        Name: data.name
      }
      api.request('Guest', 'post', '/api/MembershipCategory/Delete', reqData)
        .then(response => {
          var resData = response.data
          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage
          this.inquiry()
        })
        .catch(error => {
          status = 'error'
          message = 'Error happens when call API delete: ' + error.message
        })
      return { status: status, message: message }
    }
  }
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.form-textarea {
  flex: 1;
  width: 300px;
  resize: none;
  border: 1px solid #cfcfcf;
  padding: 8px;
  font-size: 12px;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// Cart.vue?374980d0